module.exports = __webpack_public_path__ + "static/media/icon_attribute.49b5f9af.svg";